import { useGetReservationFlowMe } from '../useGetReservationFlowMe';
import { useGetReservationFlowMerchantOptIn } from '../useGetReservationFlowOptIn';

export const useIsMulpayOrderEnabled = (
  merchant_public_id: string,
): boolean | undefined => {
  const { data: user, isLoading: isUserLoading } = useGetReservationFlowMe();
  const { data: optIn } =
    useGetReservationFlowMerchantOptIn(merchant_public_id);

  if (isUserLoading || typeof optIn === 'undefined') return undefined;
  if (user) return optIn.gmo_pg_order_enabled && user.is_gmo_pg_order_enabled;

  return optIn.gmo_pg_order_enabled;
};
